import { render, staticRenderFns } from "./PaidCodTable.vue?vue&type=template&id=2f7b3adc"
import script from "./PaidCodTable.vue?vue&type=script&lang=js"
export * from "./PaidCodTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports